const WebsiteError = ({error={}}) => `SiteError: ${error.message}`
export default WebsiteError;